import React, { Component } from "react"
import { OverlayTrigger, Spinner, Tooltip } from "react-bootstrap"
import "./ReviewsControlBar.css"

interface Props {
    ascending: boolean
    loading: boolean
    manageParentState: Function
    readOnly: boolean
    sort: Function
}


class ReviewsControlBar extends Component<Props, {}> {

    render() {

        const props = this.props
        const readOnly = props.readOnly

        const ControlBarToolTip = (text: string) => (
            <Tooltip id="review-control-bar-tool-tip">
                {text}
            </Tooltip>
        )

        return (
            <div className="ReviewsControlBar">
                {!props.loading && !readOnly && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="left" overlay={ControlBarToolTip("Add a review")}>
                    <div className="ReviewsAddReviewWrapper">
                        <span className="material-icons" onClick={() => props.manageParentState([{ key: "addReview" }])}>add</span>
                    </div>
                </OverlayTrigger>}
                {props.ascending && !props.loading && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="left" overlay={ControlBarToolTip("Sort Ascending")}>
                    <div className="ReviewsSortItems" onClick={() => props.sort()}>
                        <span id="reviews-sort-asc" className="material-icons">sort</span>
                    </div>
                </OverlayTrigger>}
                {!props.ascending && !props.loading && <OverlayTrigger delay={{ show: 0, hide: 0 }} placement="left" overlay={ControlBarToolTip("Sort Descending")}>
                    <div className="ReviewsSortItems" onClick={() => () => props.sort()}>
                        <span id="reviews-sort-desc" className="material-icons">sort</span>
                    </div>
                </OverlayTrigger>}
                {props.loading && <Spinner id="loading-reviews-spinner" animation="border" />}
            </div>
        )
    }
}

export default ReviewsControlBar